import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  PrimaryButton,
  SecondaryButton
} from 'src/components/shared/Button/Button';
import { Divider } from 'src/components/shared/Divider/Divider';
import { Header1 } from 'src/components/shared/Typography/Header1';
import { RootState, useReduxDispatch } from 'src/store';
import { alertError, alertSuccess } from 'src/store/alerts/alerts.actions';
import { postRequest } from 'src/store/api-handler';
import {
  importActions,
  parseCamsizerAnalyzes
} from 'src/store/imports/imports.actions';
import { selectImportProducts } from 'src/store/imports/imports.selectors';
import { CamsizerList } from './CamsizerList';

export const CamsizerPage = () => {
  const { t } = useTranslation();
  const dispatch = useReduxDispatch();

  const importProducts$ = useSelector((state: RootState) =>
    selectImportProducts(state.imports)
  );

  const onReadFiles = () => {
    dispatch(parseCamsizerAnalyzes());
    return new Promise(() => {});
  };

  const onImport = async () => {
    const { ok, error } = await postRequest(
      'imports/camsizer',
      importProducts$
    );
    if (ok) dispatch(alertSuccess(t('import.success')));
    else dispatch(alertError(error?.errors?.detail ?? t('import.failed')));
    dispatch(importActions.setImportProducts(null));
  };

  return (
    <React.Fragment>
      <Header1>
        {t('import.singular')} {t('import.camsizer')}
      </Header1>
      <Divider />
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <SecondaryButton onClick={onReadFiles}>
          {t('import.camsizerReadFiles')}
        </SecondaryButton>
        <PrimaryButton disabled={importProducts$ == null} onClick={onImport}>
          {t('import.verb')}
        </PrimaryButton>
      </Box>
      <Divider />
      <CamsizerList importProducts={importProducts$} />
    </React.Fragment>
  );
};
